<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs/>
        <jm-toolbar
          ref="toolbarvm"
          customize-field-name="GeneralActivity"
          show-defined-search
          show-defined-list
          size="small">
          <router-link
            slot="beforeDefinedSearch"
            class="button-search"
            target="_blank"
            :to="{ name: 'activityEdit', params: { id: 0 } }">
            <el-button
              type="primary"
              size="medium">添加通用活动</el-button>
          </router-link>
          <router-link
            v-if="isFibSite"
            slot="beforeDefinedSearch"
            class="button-search icon-index-1"
            target="_blank"
            :to="{ name: 'addStudentSimple', params: { acId: 0 } }">
            <el-button
              type="primary"
              size="medium">添加学生信息
            </el-button>
          </router-link>
          <router-link
            v-if="isTrainingSite"
            slot="beforeDefinedSearch"
            class="button-search icon-index-1"
            target="_blank"
            :to="{ name: 'addSimple', params: { acId: 0 } }">
            <el-button
              type="primary"
              size="medium">添加学生信息
            </el-button>
          </router-link>
        </jm-toolbar>
        <div class="table-agile-info">
          <div class="searchList">
            <el-form
              :model="searchData"
              inline>
              <jm-form-options
                :options="searchStructure"
                :option-data="searchData"
                :need-filter="true"
                :const-dict="options"/>
            </el-form>
          </div>
          <div class="searchBottom">
            <el-button
              type="primary"
              class="jm-input-common3"
              @click="getSearch">查询</el-button>
            <el-button
              type="default"
              class="jm-input-common3"
              @click="setSearchData">重置</el-button>
          </div>
          <jm-tableList
            url="/index/general_activity/getPage"
            :refresh="refresh"
            :search-data="searchData"
            :current-page.sync="currentPage">
            <el-table-column
              slot="lastColumn"
              label="操作"
              width="260"
              align="center"
              fixed="right">
              <template slot-scope="scope">
                <a
                  :href="`${urlPrefix}/activity/info/${scope.row.id}`"
                  v-if="checkUser(
                    [...scope.row.view_userid, scope.row.creator_userid]
                  )"
                  target="_blank"
                  title="查看详情"><el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-document">查看
                </el-button></a>
                <a
                  :href="`${urlPrefix}/activity/edit/${scope.row.id}`"
                  v-if="checkUser([scope.row.creator_userid])"
                  title="编辑"><el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-edit-outline">编辑
                </el-button></a>
                <el-button
                  type="danger"
                  size="mini"
                  v-if="checkUser([scope.row.creator_userid])"
                  @click="toogleStatus(scope.row)"
                  icon="el-icon-edit-outline">{{
                    scope.row.act_status == '有效' ? '禁用' : '启用'
                  }}
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              slot="act_status"
              slot-scope="scope"
              v-bind="scope.attrs"
              label="活动状态"
              property="act_status"
            >
              <template slot-scope="scope">
                <el-tag v-if="scope.row.act_status_real === 1" type="success">有效</el-tag>
                <el-tag v-if="scope.row.act_status_real === 2" type="danger">无效</el-tag>
              </template>
            </el-table-column>
          </jm-tableList>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import jmToolbar from '@/components/tool/toolbar';
import jmTableList from '@/components/data/tableList';
import { jmDictSelect } from '@/components/tool';
import { filterVisible } from '@/utils/utils';
import jmFormOptions from '@/components/data/formOptions';

// 搜索项结构
const searchStructure = [
  {
    visible: 'activity_code',
    field: 'activity_code',
    label: '活动编号',
    placeholder: '活动编号',
    component: 'input',
    column: [24, 12, 8, 8]
  },
  {
    visible: 'act_title',
    field: 'act_title',
    label: '活动名称',
    placeholder: '活动名称',
    component: 'input',
    column: [24, 12, 8, 8]
  },
  {
    visible: 'act_type',
    field: 'act_type',
    label: '活动目的',
    placeholder: '活动目的',
    component: 'dict',
    type: 'dataset',
    dict: 'activity',
    name: 'actType',
    clearable: true,
    column: [24, 12, 8, 8]
  },
  {
    visible: 'budget',
    field: 'budget',
    label: '活动预算',
    placeholder: '活动预算',
    component: 'input',
    type: 'number',
    column: [24, 24, 24, 8]
  },
  {
    visible: 'act_remark',
    field: 'act_remark',
    label: '活动备注',
    placeholder: '活动备注',
    component: 'input',
    column: [24, 12, 8, 8]
  },
  {
    visible: 'act_status',
    field: 'act_status',
    label: '活动状态',
    placeholder: '活动状态',
    component: 'dict',
    type: 'dataset',
    dict: 'student',
    name: 'actStatus',
    clearable: true,
    column: [24, 12, 8, 8]
  },
  {
    visible: 'star_time',
    field: 'star_time',
    label: '开始时间',
    placeholder: '开始时间',
    component: 'timeline',
    format: 'yyyy-MM-dd HH:mm:ss',
    column: [24, 24, 16, 8],
    pickerOptions: {
      disabledDate() {
        return false;
      }
    }
  },
  {
    visible: 'end_time',
    field: 'end_time',
    label: '结束时间',
    placeholder: '结束时间',
    component: 'timeline',
    format: 'yyyy-MM-dd HH:mm:ss',
    column: [24, 24, 16, 8],
    pickerOptions: {
      disabledDate() {
        return false;
      }
    }
  }
];
  // options
const options = {
};
  // 搜索数据结构
const searchData = {
  activity_code: '',
  act_remark: '',
  act_status: '',
  act_title: '',
  end_time: 0,
  id: '',
  star_time: '',
  act_type: '',
  budget: ''
};

export default {
  components: {
    jmToolbar, jmTableList, jmDictSelect, jmFormOptions
  },
  data() {
    return {
      tableListInited: false,
      searchStructure,
      appOrder: 0,
      options,
      searchData: {},
      currentPage: 1,
      urlPrefix: ''
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    // 监听状态刷新数据
    refresh() {
      return this.$store.state.student.refresh;
    },
  },
  methods: {
    filterVisible,
    // 初始默认搜索值
    setSearchData() {
      this.searchData = Object.assign({}, searchData);
    },
    getSearch() {
      this.currentPage = 1;
      this.searchData.isSearch = false;
      Object.values(this.searchData).forEach((item) => {
        if (item) {
          this.searchData.isSearch = true;
        }
      });
      this.$store.commit('updateRefresh', true);
    },
    checkUser(viewUserid) {
      let userid = this.$store.getters.userInfo.userid;
      viewUserid.push(1);
      return viewUserid.find(v => v === userid);
    },
    toogleStatus (row) {
      const status = row.act_status_real === 1 ? 2 : 1;
      this.$http._post({
        url: '/index/general_activity/updateById',
        data: { id: row.id, params: { act_status: status } }
      }).then(() => {
        this.getSearch();
      });
    }
  },
  created() {
    // 因为默认查询字段为空，初始设置查询数据字段
    this.setSearchData();
    if (this.$siteName === 'fib') {
      this.urlPrefix = '/frontend';
    }
  },
  watch: {
  }
};
</script>

<style scoped>
  .button-search {
    margin-right: 10px;
    display: inline-block;
    height: 100%;
  }
</style>
